import * as types from './types';
import * as commonTypes from '../common/types';

export default (state = {}, action) => {
    switch (action.type) {
        case commonTypes.ASYNC_START: {
            return {
                ...state,
                loading: true,
                waitting: action.waitting,
                action: commonTypes.ASYNC_START,
            }
        }

        case commonTypes.ASYNC_END: {
            return {
                ...state,
                action: commonTypes.ASYNC_END,
                waitting: commonTypes.ASYNC_END,
                loading: false,
            }
        }
        case types.LADIPAGE_CONTENT_AUDIT_LIST: {
            return {
                ...state,
                action: types.LADIPAGE_CONTENT_AUDIT_LIST,
                items: action.status ? action.payload.items : [],
                status: action.status,
                message: action.message,
                totalRecord: action.status ? action.payload.total : 0,
                totalPage: action.status ? action.payload.total_page : 0,
            }
        }
        case types.ACTIVITY_LIST: {
            return {
                ...state,
                action: types.ACTIVITY_LIST,
                activities: action.status ? action.payload.items : [],
                excelDatas: action.status ? action.payload.excelDatas : [],
                totalRecord: action.status ? action.payload.total : 0,
                totalPage: action.status ? action.payload.total_page : 0,
                status: action.status,
                message: action.message,
            }
        }
        case types.EXPORT_ACTIVITY: {
            return {
                ...state,
                action: types.EXPORT_ACTIVITY,
                url: action.status ? action.payload.url : '',
                status: action.status,
                message: action.message,
            }
        }
        default:
            return state;
    }
}

